import { observer } from 'mobx-react-lite';
import PointsOfInterestHeader from './PointsOfInterestHeader';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { POINT_OF_INTERESTS } from './PointOfInterestConst';
import PointOfInterestImage from './PointOfInterestImage';
import PointOfInterestMap from './PointOfInterestMap';

function PointsOfInterest({ data }) {
    const [selectedPoint, setSelectedPoint] = useState('');

    const getPointColor = useCallback(
        (name) => {
            return selectedPoint === name ? '#B4CE45' : '#4887C7';
        },
        [selectedPoint]
    );
    const onPointClick = point => setSelectedPoint(point);

    const pointOfInterests = useMemo(() => {
        if (data?.sections?.length === 0) {
            return POINT_OF_INTERESTS;
        }

        const results = [];
        data?.sections?.map(section => {
            const name = section.attributes?.country || '';
            const description = section.attributes?.description || '';
            const key = section.key || '';
            const image = section.attributes?.country_image?.files?.medium?.url || '';
            const color = getPointColor(name);
            results.push({
                name: name,
                description: description,
                color: color,
                key: key,
                image: image,
            });
            return section;
        });

        return results;
    }, [data, getPointColor]);

    useEffect(() => {
        onPointClick('UAE');
    }, []);

    return (
        <>
            <PointsOfInterestHeader
                pointsOfInterest={pointOfInterests}
                selectedPoint={selectedPoint}
                onPointClick={onPointClick}
            />
            <div className="row">
                <div className='col-md-3'>
                    <div className="max-md:pr-8">
                        <h3 className="pb-4 text-small fw-semibold uppercase md:pb-8 md:text-h3">{selectedPoint}</h3>
                        <div
                            className="columns-1 md:columns-2 space-y-2"
                            dangerouslySetInnerHTML={{
                                __html: pointOfInterests.find(point => point.name === selectedPoint)?.description,
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-9'>
                    <div className="row">
                        <div className='col-md-6'>
                            <PointOfInterestMap
                                onLocationClick={onPointClick}
                                getPointColor={getPointColor}
                                className="h-full w-full"
                                style={{ backgroundColor: '#FAFBFD' }}
                            />
                        </div>
                        <div className='col-md-6'>
                            <PointOfInterestImage selectedPoint={selectedPoint} pointOfInterests={pointOfInterests} data={data} />
                        </div>
                    </div>
                </div>                             
            </div>
        </>
    );
}

export default observer(PointsOfInterest);
